import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store, { history } from './configureStore';
import App from './app/App';
import { unregister } from './registerServiceWorker';
import { ConnectedRouter } from 'connected-react-router';
import { configureAmplify } from './app/configureAmplify';

configureAmplify();

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);

unregister();
